<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [subheader]="data.description" />
  </ng-container>

  <ng-container body>
    <div class="technical-details-box">
      <email-text
        [contents]="data.technical_details"
        color="light"
        presetName="inline"
        size="small"
      />
    </div>
    <email-margin [height]="28" />
    <email-text [contents]="data.action_needed" color="light" presetName="inline" size="small" />
    <email-margin [height]="16" />
    <email-button [href]="data.go_to_settings_link" [label]="data.go_to_settings_text" />
  </ng-container>

  <ng-container footer>
    <email-text
      [contents]="data.footer.text"
      color="light"
      presetName="inline"
      size="small"
    />&nbsp;
    <email-link
      [label]="data.footer.label"
      [href]="data.footer.href"
      [target]="data.footer.target"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
